import { apiFetch } from "./client";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  if (params.status) search.set("status", params.status);
  if (params.customerId) search.set("customerId", params.customerId);
  if (params.query) search.set("q", params.query);
  if (params.page) search.set("page", params.page);
  if (params.limit) search.set("limit", params.limit);
  return search.toString() ? `?${search.toString()}` : "";
};

const fetchInvoices = async (options = {}) => {
  const suffix = buildQuery(options);
  return apiFetch(`/api/invoices${suffix}`);
};

const fetchInvoice = async (id) => {
  if (!id) throw new Error("Invoice id is required");
  return apiFetch(`/api/invoices/${id}`);
};

const createInvoice = async (payload = {}) =>
  apiFetch("/api/invoices", {
    method: "POST",
    body: JSON.stringify(payload),
  });

const updateInvoice = async (id, payload = {}) => {
  if (!id) throw new Error("Invoice id is required to update.");
  return apiFetch(`/api/invoices/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

const recordInvoicePayment = async (id, payload = {}) => {
  if (!id) throw new Error("Invoice id is required to record a payment.");
  return apiFetch(`/api/invoices/${id}/payments`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

const logInvoiceEvent = async (id, payload = {}) => {
  if (!id) throw new Error("Invoice id is required to log an event.");
  return apiFetch(`/api/invoices/${id}/events`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

const fetchPaymentReceipt = async (invoiceId, paymentId) => {
  if (!invoiceId || !paymentId) throw new Error("Invoice id and payment id are required to fetch a receipt.");
  return apiFetch(`/api/invoices/${invoiceId}/payments/${paymentId}/receipt`);
};

export {
  fetchInvoices,
  fetchInvoice,
  createInvoice,
  updateInvoice,
  recordInvoicePayment,
  logInvoiceEvent,
  fetchPaymentReceipt,
};
